"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CompetitionsMap;
var _react = _interopRequireDefault(require("react"));
var _reactGoogleMaps = require("@vis.gl/react-google-maps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MAPS_API_KEY = 'AIzaSyDRm0oFU3j1FECyHOxTlkfnH_APXyD07L8';
const baseMap = {
  center: {
    lat: 54.5,
    lng: -3
  },
  height: 700,
  zoom: 6,
  gestureHandling: 'greedy',
  disableDefaultUI: true
};
function CompetitionsMap({
  mapLabels
}) {
  const clusterLabels = [];
  mapLabels.map(ml => {
    let found = false;
    clusterLabels.map(cl => {
      if (cl.sitePosition.lat === Math.round(ml.sitePosition.lat * 100) / 100 && cl.sitePosition.lng === Math.round(ml.sitePosition.lng * 100) / 100) {
        cl.siteLocation = cl.siteLocation + ', ' + ml.siteLocation;
        cl.races = cl.races + ml.races;
        found = true;
      }
    });
    if (!found) {
      const clusterSitePosition = {
        lat: Math.round(ml.sitePosition.lat * 100) / 100,
        lng: Math.round(ml.sitePosition.lng * 100) / 100
      };
      clusterLabels.push({
        ...ml,
        sitePosition: clusterSitePosition
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.APIProvider, {
    apiKey: MAPS_API_KEY
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Map, {
    style: {
      height: baseMap.height
    },
    defaultCenter: baseMap.center,
    defaultZoom: baseMap.zoom,
    gestureHandling: baseMap.gestureHandling,
    disableDefaultUI: baseMap.disableDefaultUI
  }, clusterLabels.map(ml => /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Marker, {
    key: ml.siteLocation,
    position: ml.sitePosition,
    label: ml.races + '',
    title: ml.siteLocation
  })))));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************